@if (showEnvironmentLabel) {
  <div class="environment-label">{{ environment }}</div>
}
<router-outlet></router-outlet>
